import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";

const MultiSelectWithCheckboxWorkflowEdit = ({
  options,
  selectedValues = [],
  onChange,
  selectedIds,
  setSelectedIds,
  selectedNames,
  setSelectedNames,
  selectedOptions,
  setSelectedOptions,
}) => {
  

  // Handle change when checkboxes are selected
  const handleSelectionChange = (selected) => {
    if (!Array.isArray(selected)) return;

    const uniqueSelections = Array.from(new Set(selected.map((option) => option.id))).map((id) =>
      selected.find((option) => option.id === id)
    );

    setSelectedOptions(uniqueSelections);
    setSelectedIds(uniqueSelections.map((option) => option.id));
    setSelectedNames(uniqueSelections.map((option) => option.label));

    onChange({
      selectedIds: uniqueSelections.map((option) => option.id),
      selectedNames: uniqueSelections.map((option) => option.label),
    });
  };

  // Custom option with checkboxes
  const customOption = ({ data, innerRef, innerProps }) => (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "5px 10px",
        cursor: "pointer",
        fontSize: "16px",
      }}
    >
      <input
        type="checkbox"
        checked={selectedOptions.some((option) => option.id === data.id)}
        readOnly
        style={{ marginRight: "10px" }}
      />
      {data.label}
    </div>
  );

  // Custom dropdown indicator
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <span className="pointer-events-none">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
              stroke="#245CEA"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </span>
      </components.DropdownIndicator>
    );
  };

  // Custom styles for font size
  const customStyles = {
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "16px",
        padding:"0px"
    }),
  };

  // Custom components for select
  const customComponents = {
    Option: customOption,
    DropdownIndicator,
    IndicatorSeparator: () => null,
  };

  return (
    <Select
      options={options}
      components={customComponents}
      isMulti
      value={selectedOptions}
      onChange={handleSelectionChange}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      placeholder="Search and select Recruiters..."
      styles={customStyles} // Use custom styles here
    />
  );
};

export default MultiSelectWithCheckboxWorkflowEdit;
